// extracted by mini-css-extract-plugin
export default {"container":"AlterarAviso_container__suFl-"};